import { useMemo } from 'react';

import find from 'lodash/find';

import {
  EntityApiApiV2EntityFacilityBasedLaborLevelsGetRequest,
  LaborLevelResponse,
  useFacilityLaborLevelWithOptionsGet,
} from '@sbv-clients/data-access-api';

import {
  BaseFieldProps,
  createOptionsFieldBuilder,
} from '../hoc/fields-builder';

const defaultGetLaborLevelLevelLabel = (child: LaborLevelResponse): string =>
  `${child.laborLevelId} - ${child.laborLevelDescription}`;

const useOptionsHook = ({
  facilityPkId,
  level,
  getLaborLevelLevelLabel = defaultGetLaborLevelLevelLabel,
}: EntityApiApiV2EntityFacilityBasedLaborLevelsGetRequest & {
  level: number;
  getLaborLevelLevelLabel?: (child: LaborLevelResponse) => string;
}) => {
  const {
    options: baseOptions,
    isLoading,
    isSuccess,
  } = useFacilityLaborLevelWithOptionsGet(
    { facilityPkId },
    { getLaborLevelLevelLabel }
  );
  const options = useMemo(() => {
    return (
      find(baseOptions, (item) => item.meta.level === level)?.children ?? []
    );
  }, [baseOptions, level]);
  return { options, isLoading, isSuccess };
};

type ExtraParameters = Parameters<typeof useOptionsHook>[0];

type Props = BaseFieldProps & ExtraParameters;

const hookParamsGetter = (props: Props): ExtraParameters => props;

export const {
  LaborLevelLevelsFacilitySelectField,
  LaborLevelLevelsFacilityFormSelectField,
  LaborLevelLevelsFacilityDataGridSelectField,
} = createOptionsFieldBuilder({
  prefix: 'LaborLevelLevelsFacility',
  useOptionsHook: useOptionsHook,
  extractHookParams: hookParamsGetter,
});
